import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {Object}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing an areas icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <AreasIcon width={12} />
 */
const AreasIcon = props => (
    <SvgIcon viewBox="0 0 48 48" {...props}>
        <path
            d={`M31.135,42.482a2.037,2.037,0,0,1-.543-.058L7.4,36.716a1.958,
                1.958,0,0,1-1.507-1.89l0-18.209A1.943,1.943,0,0,1,6.954,14.9L26.6,
                4.695a2.021,2.021,0,0,1,2.593.638L41.557,23.412a1.911,1.911,0,0,
                1,.1,2.005L32.835,41.456A2,2,0,0,1,31.135,42.482ZM9.882,33.307l20.177,
                4.966L37.576,24.6,26.881,8.964l-17,8.825Z`}
        />
    </SvgIcon>
)

AreasIcon.defaultProps = defaultProps

export { AreasIcon }
